.search {
  position: relative;
  display: flex;
  align-items: center;
  inline-size: 260px;
  max-inline-size: 100%;
}

.icon {
  position: absolute;
  inset-inline-start: 10px;
  display: inline-flex;
  color: var(--text-subtle);
  pointer-events: none;
}

.input {
  box-sizing: border-box;
  inline-size: 100%;
  min-inline-size: 0;
  block-size: var(--control-height);
  padding: 0 10px 0 32px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
}

.input:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
  box-shadow: 0 0 0 3px var(--action-soft);
}

.input::placeholder {
  color: var(--text-subtle);
}
